<template>
  <template v-for="(comp, index) in components" :key="comp.uniqueTitle || index">
    <component
      :is="comp"
      v-if="comp"
      v-bind:items="comp.items"
      v-bind:uniqueTitle="comp.uniqueTitle"
      v-bind:title="comp.titleValue"
      v-bind:formComponents="comp.formComponents"
      v-bind:columnFormat="comp.columnFormat"
      v-bind:components="comp.components"
      v-bind:isEditForm="comp.isEditForm"
      v-bind:submissionRules="comp.submissionRules"
      v-bind:twoFactor="comp.twoFactorValue"
      v-bind:defaultValueRules="comp.defaultValueRules"
      v-bind:formActions="comp.formActions"
      v-bind:userFiltering="comp.userFilteringValue"
      v-bind:pageUniqueTitle="comp.pageUniqueTitleValue"
      v-bind:componentUniqueTitle="comp.componentUniqueTitleValue"
      v-bind:chartType="comp.chartTypeValue"
      v-bind:realtime="comp.realtimeValue"
      v-bind:csvExport="comp.csvExportValue"
      v-bind:tableLayout="comp.tableLayoutValue"
      v-bind:searchEnabled="comp.searchEnabledValue"
      v-bind:filterButtons="comp.filterButtonsValue"
      v-bind:allowMultipleFilterButtons="comp.allowMultipleFilterButtonsValue"
      v-bind:defaultUserFilters="comp.defaultUserFiltersValue"
      v-bind:defaultUserFilterMatchMode="comp.defaultUserFilterMatchModeValue"
      v-bind:restrictUserFiltering="comp.restrictUserFilteringValue"
      v-bind:pivotConfig="comp.pivotConfigValue"
      v-bind:viewCode="comp.viewCodeValue"
      v-bind:viewCss="comp.viewCssValue"
      v-bind:spreadSheetUniqueTitle="comp.spreadSheetUniqueTitleValue"
      v-bind:richTextContent="comp.richTextContentValue"
      v-bind:staticImageId="comp.staticImageIdValue"
      v-bind:altText="comp.altTextValue"
    />
  </template>
</template>

<script>
export default {
  name: 'PageComponents',
  props: {
    components: {
      type: Array,
      default: () => []
    }
  }
}
</script>
